var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.900002 2.49999C0.900002 2.30669 1.0567 2.14999 1.25 2.14999H3.75C3.9433 2.14999 4.1 2.30669 4.1 2.49999V4.99999C4.1 5.19329 3.9433 5.34999 3.75 5.34999H1.25C1.0567 5.34999 0.900002 5.19329 0.900002 4.99999V2.49999ZM1.6 2.84999V4.64999H3.4V2.84999H1.6Z",
    fill: "#0E0F12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.900002 6.99999C0.900002 6.80669 1.0567 6.64999 1.25 6.64999H3.75C3.9433 6.64999 4.1 6.80669 4.1 6.99999V9.49999C4.1 9.69329 3.9433 9.84999 3.75 9.84999H1.25C1.0567 9.84999 0.900002 9.69329 0.900002 9.49999V6.99999ZM1.6 7.34999V9.14999H3.4V7.34999H1.6Z",
    fill: "#0E0F12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 2.49999C5.4 2.30669 5.5567 2.14999 5.75 2.14999H10.75C10.9433 2.14999 11.1 2.30669 11.1 2.49999V4.99999C11.1 5.19329 10.9433 5.34999 10.75 5.34999H5.75C5.5567 5.34999 5.4 5.19329 5.4 4.99999V2.49999ZM6.1 2.84999V4.64999H10.4V2.84999H6.1Z",
    fill: "#0E0F12"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.4 6.99999C5.4 6.80669 5.5567 6.64999 5.75 6.64999H10.75C10.9433 6.64999 11.1 6.80669 11.1 6.99999V9.49999C11.1 9.69329 10.9433 9.84999 10.75 9.84999H5.75C5.5567 9.84999 5.4 9.69329 5.4 9.49999V6.99999ZM6.1 7.34999V9.14999H10.4V7.34999H6.1Z",
    fill: "#0E0F12"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.d4082a8d.svg";
export { ForwardRef as ReactComponent };